import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	loading: {
		id: 'SoftwareRovoStart.Page.loading',
		defaultMessage: 'Loading',
	},
	login: {
		id: 'SoftwareRovoStart.Page.login',
		defaultMessage: 'Login',
	},
	contactSales: {
		id: 'SoftwareRovoStart.Page.contactSales',
		defaultMessage: 'Contact Sales',
	},
	rovoGetStarted: {
		defaultMessage: 'Get <started>started</started> with Rovo',
		description: 'Title text for WAC Rovo Start_logged out page',
		id: 'SoftwareRovoStart.Page.rovoGetStarted',
	},
	loginButtonRovo: {
		defaultMessage: 'Log in',
		id: 'SoftwareRovoStart.Page.loginButtonRovo',
	},
	rovoBodyText: {
		defaultMessage: 'Log in to add it to your organization',
		id: 'SoftwareRovoStart.Page.rovoBodyText',
	},
	dontHaveAccountText: {
		defaultMessage: 'Don’t have an account?',
		id: 'SoftwareRovoStart.Page.dontHaveAccountText',
	},
	contactAtlassianText: {
		defaultMessage: '<a>Contact Atlassian</a>',
		id: 'SoftwareRovoStart.Page.contactAtlassianText',
	},
	errorScreenTitle: {
		defaultMessage: 'Something went wrong',
		description: 'Error screen title',
		id: 'SoftwareRovoStart.Page.errorScreenTitle',
	},
	errorScreenMessageOne: {
		defaultMessage: '<a>Contact support</a> for further help or try again.',
		description: 'Error screen message part one',
		id: 'SoftwareRovoStart.Page.errorScreenMessageOne',
	},
	errorScreenMessageTwo: {
		defaultMessage: 'To receive a quote for Rovo, <a>contact sales.</a>',
		description: 'Error screen message part two',
		id: 'SoftwareRovoStart.Page.errorScreenMessageTwo',
	},
});
